import { Directive, ElementRef, Input, HostListener, Renderer } from '@angular/core';
var ActiveDirective = (function () {
    function ActiveDirective(el, renderer) {
        this.renderer = renderer;
        this.el = null;
        this.elLabel = null;
        this.elIcon = null;
        this.el = el;
    }
    ActiveDirective.prototype.onClick = function () {
        this.initComponent();
    };
    ActiveDirective.prototype.onBlur = function () {
        this.checkValue();
    };
    ActiveDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.initComponent();
        this.checkValue();
        setTimeout(function () {
            _this.checkValue();
        }, 0);
    };
    ActiveDirective.prototype.initComponent = function () {
        var inputId;
        var inputP;
        try {
            inputId = this.el.nativeElement.id;
        }
        catch (err) { }
        try {
            inputP = this.el.nativeElement.parentNode;
        }
        catch (err) { }
        this.elLabel = inputP.querySelector('label[for="' + inputId + '"]') || inputP.querySelector('label');
        if (this.elLabel != null) {
            this.renderer.setElementClass(this.elLabel, 'active', true);
        }
        this.elIcon = inputP.querySelector('i') || false;
        if (this.elIcon) {
            this.renderer.setElementClass(this.elIcon, 'active', true);
        }
    };
    ActiveDirective.prototype.checkValue = function () {
        var value = '';
        if (this.elLabel != null) {
            value = this.el.nativeElement.value || '';
            if (value === '') {
                this.renderer.setElementClass(this.elLabel, 'active', false);
                if (this.elIcon) {
                    this.renderer.setElementClass(this.elIcon, 'active', false);
                }
            }
            else {
                this.renderer.setElementClass(this.elLabel, 'active', true);
            }
        }
    };
    return ActiveDirective;
}());
export { ActiveDirective };
ActiveDirective.decorators = [
    { type: Directive, args: [{
                selector: '[mdbActive]'
            },] },
];
/** @nocollapse */
ActiveDirective.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer, },
]; };
ActiveDirective.propDecorators = {
    'mdbActive': [{ type: Input },],
    'onClick': [{ type: HostListener, args: ['focus', ['$event'],] },],
    'onBlur': [{ type: HostListener, args: ['blur', ['$event'],] },],
};
//# sourceMappingURL=active.class.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/inputs/active.class.js
// module id = ../../../../angular-bootstrap-md/inputs/active.class.js
// module chunks = 3